import { SectionName } from './models/section-name';
import { ApiEnvironment } from '../../models/api-environment';

export class TripManagementSettingsEnvironment extends ApiEnvironment {
  configurationSectionNameUrl(sectionName?: SectionName) {
    return `${this.baseUrl}/api/v1/configuration/${sectionName ? sectionName : ''}`;
  }

  get configurationWeatherAlerts() {
    return `${this.baseUrl}/api/v1/configuration/weatherAlerts`;
  }

  override resolve(environment: unknown) {
    return environment instanceof TripManagementSettingsEnvironment
      ? environment
      : this;
  }
}

export const tripManagementSettingsEnvironment =
  new TripManagementSettingsEnvironment();
